export default __webpack_public_path__ + "dist/img/logo.png";